import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Row, Col, Button } from "react-bootstrap";
import moment from "moment";
import ReactPaginate from "react-paginate";
import { isEqual } from "lodash";
import { intersection } from 'lodash'
import withFetchHook from "../withFetchHook";

class GoalsTab extends Component {
  state = {
    curentPage: 1
  };

  componentDidMount() {
    if (this.props.isActive) {
      this.fetchGoals();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { isActive } = this.props;
    if (isActive && (!isEqual(prevState, this.state) || prevProps.isActive !== isActive)) {
      this.fetchGoals();
    }
  }

  fetchGoals() {
    const { organizationName, residentId, isActive } = this.props;
    const { currentPage } = this.state;
    
    if (!isActive) return;

    this.props.fetch(`/organizations/${organizationName}/residents/${residentId}/goals.json`, {
      data: {
        page: currentPage
      }
    }).then((goal_subscriptions) => {
      this.props.updateGoalSubscriptions(goal_subscriptions);
    })
  }

  renderPagination() {
    const { total_pages } = this.props.goal_subscriptions;
    const { currentPage } = this.state;

    return (
      <ReactPaginate
        containerClassName="pagination"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        activeClassName="active"
        pageCount={total_pages}
        onPageChange={(page) =>
          this.setState({ currentPage: page.selected + 1 })
        }
      />
    );
  }

  render() {
    const { organizationName, residentId, permissions } = this.props;
    const { goal_subscriptions } = this.props.goal_subscriptions;

    return (
      <>
        <div className="d-flex justify-content-center mt-4">
          {this.renderPagination()}
        </div>
        <Row>
          {
            goal_subscriptions.map((goal_subscription, i) => {
              return (
                <Col xs={12} sm={6} key={i}>
                  <Card>
                    <div className="card-block">
                      <Card.Title>
                        <a href={`/organizations/${organizationName}/residents/${residentId}/goals/${goal_subscription.goal.id}`}>{goal_subscription.goal.title}</a>
                      </Card.Title>
                      <Card.Text>{goal_subscription.goal.description}</Card.Text>
                      {
                        goal_subscription.completed &&
                        <Card.Text className="badge badge-success">Completed</Card.Text>
                      }
                      <Card.Text>
                        <strong>Due: </strong>
                        <span>{goal_subscription.goal.due ? moment(goal_subscription.goal.due).format("MM/DD/YYYY @ hh:mm a") : null}</span>
                      </Card.Text>
                      {
                        intersection(permissions, ["edit_everything"]).length > 0 &&
                        <a href={`/organizations/${organizationName}/residents/${residentId}/goals/${goal_subscription.goal.id}/edit`}>Edit</a>
                      }
                    </div>
                  </Card>
                </Col>
              );
            })
          }
          <Col xs={12} className="d-flex justify-content-center">
            <Button
              variant="link"
              href={`/organizations/${organizationName}/residents/${residentId}/goals/new`}>
              New Goal
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    goal_subscriptions: state.goal_subscriptions,
    organizationName: state.organization.name,
    residentId: state.resident.id,
    permissions: state.permissions,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateGoalSubscriptions: (goal_subscriptions) =>
      dispatch({ type: "UPDATE_GOALSUBSCRIPTIONS", payload: { goal_subscriptions } }),
    updatePage: (currentPage) =>
      dispatch({ type: "UPDATE_CURRENT_PAGE", payload: { currentPage } }),
  };
};

export default withFetchHook(
  connect(mapStateToProps, mapDispatchToProps)(GoalsTab)
);
